import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IBlog, IBlogDetail } from 'src/app/shared/models/Iblog';
import { BlogService } from 'src/app/shared/services/blog.service';

@Component({
  selector: 'app-blog-content',
  templateUrl: './blog-content.component.html',
  styleUrls: ['./blog-content.component.scss']
})
export class BlogContentComponent implements OnInit {
  id: number;
  listBlogs: IBlog[];
  blogContent: IBlogDetail = {
    id: 1,
    title: '',
    content: '',
    imgBlog: `'../../../../assets/img/BLOG/Fondo blog.svg'`
  };
  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private _blogService: BlogService) {
    this.id = Number(this.activatedRoute.snapshot.paramMap.get('id'));
    this.onSetBlog(this.id);
  }

  ngOnInit(): void {
    // this.listBlogs = this._blogService.collection
    //   .filter(x => x.id > this.id)
    //   .slice(0, 2);
    this._blogService.getBlogs().subscribe((data: IBlog[]) => {
      this.listBlogs = data;
    }, error => {
      console.error('Error fetching blogs:', error);
    });
  }
  onSetBlog(id: number) {
    this.blogContent = this._blogService.collectionBLOG
      .find(r => r.id == id);
    if (this.blogContent == null) {
      this.router.navigate(["/"]);
    }
  }
}
